"use client";
import _extends from "@babel/runtime/helpers/esm/extends";
import ltLocale from "date-fns/locale/lt";

var Calendar = {
	sunday: "S",
	monday: "P",
	tuesday: "A",
	wednesday: "T",
	thursday: "K",
	friday: "P",
	saturday: "Š",
	ok: "OK",
	today: "šiandien",
	yesterday: "vakar",
	hours: "valandos",
	minutes: "minutės",
	seconds: "sekundės",
	formattedMonthPattern: "MMMM yyyy",
	formattedDayPattern: "dd MMMM yyyy",
	dateLocale: ltLocale,
};
var Combobox = {
	noResultsText: "Nieko nerasta",
	placeholder: "Pasirinkite",
	searchPlaceholder: "Ieškoti",
	checkAll: "Visi",
};
export default {
	code: "lt-LT",
	common: {
		loading: "Kraunama…",
		emptyMessage: "Nėra duomenų",
		remove: "Pašalinti",
		clear: "Išvalyti",
	},
	Plaintext: {
		unfilled: "Tuščia",
		notSelected: "Nepasirinkta",
		notUploaded: "Neįkelta",
	},
	Pagination: {
		more: "Daugiau",
		prev: "Ankstesnis",
		next: "Kitas",
		first: "Pirmas",
		last: "Paskutinis",
		limit: "{0} / puslapių",
		total: "Eilučių: {0}",
		skip: "Pereiti į: {0}",
	},
	DateTimeFormats: Calendar,
	Calendar: Calendar,
	DatePicker: Calendar,
	DateRangePicker: _extends({}, Calendar, {
		last7Days: "paskutinės 7 dienos",
	}),
	Combobox: Combobox,
	InputPicker: {
		newItem: "Naujas elementas",
		createOption: 'Sukurti parinktį "{0}"',
	},
	TagPicker: {
		newItem: "Naujas elementas",
		createOption: 'Sukurti parinktį "{0}"',
	},
	Uploader: {
		inited: "Pradinis",
		progress: "Įkeliama",
		error: "Klaida",
		complete: "Baigta",
		emptyFile: "Tuščias",
		upload: "Įkelti",
		removeFile: "Pašalinti failą",
	},
	CloseButton: {
		closeLabel: "Uždaryti",
	},
	Breadcrumb: {
		expandText: "Rodyti kelią",
	},
	Toggle: {
		on: "Įjungta",
		off: "Išjungta",
	},
};
